import { _,Backbone,Marionette,Radio,moment,Foundation } from '../../vendor'
import InboomaBaseView from '../views/InboomaBaseView'
import { appRollingLoaderAnim } from '../views/AppAnnouncements'
import { Biscuit } from '../utils'
import {getContentModifications} from "../App";
/**
 * @file utils/Behavior.OffCanvas
 * @author Felx Albroscheit
 * 
 * Base functions for close- and submit-actions in OffCanvas elements.
 * Interacts with Backform-form and Backbone-model.
 * 
 * @todo Enable transitions and/or child-views
 */

const appChannel = Radio.channel('app');

const headerRegionView = InboomaBaseView.extend({

  template : _.template(`
      <%= t('created_at') %> 
      <%- moment(created).format('Do MMMM YYYY, HH:mm') %>
      <% if (created_by && typeof created_by.get !== 'undefined') { %>
        <%= t('edited_by') %> <%- created_by.get('first_name') %> <%- created_by.get('last_name') %>
        <% if (created_by.get('deleted') !== null && created_by.get('deleted') !== '') { %>
        (<%= t('customer_removed') %>)
        <% } %>
      <% } %>

      <% if (modified !== ''){ %>
        | <%= t('last_modified_at') %> <%- moment(modified).format('Do MMMM YYYY, HH:mm') %>
        <% if (modified_by && typeof modified_by.get !== 'undefined') { %>
          <%= t('edited_by') %>
          <%- modified_by.get('first_name') %> <%- modified_by.get('last_name') %>      
          <% if (modified_by.get('deleted') !== null && modified_by.get('deleted') !== '') { %>
            (<%= t('customer_removed') %>)
          <% } %>
        <% } %>
      <% } %>
      
      <%- extraHeaderRegionContent %>
  `),

  templateContext () {
      return {
        moment,
        extraHeaderRegionContent: _.template(this.getOption('extraHeaderRegionContent'))({
            moment,
            t : (a,b,c) => InboomaBaseView.prototype.t(a,b,c),
            ...this.model.attributes,
            Biscuit,
            _exchangeLabel : (value) => {
                let cm = getContentModifications();

                if (cm.labels != null) {
                    if (cm.labels[value] !== undefined) {
                        return cm.labels[value];
                    }
                }
                return value;
            },
        })
      }
  },

  initialize () {
      this.fetchUsersAndRender();
  },

  fetchUsersAndRender () {

      if (this.model.get('id') !== '') {

        if (this.model.get('created') === this.model.get('modified')) {
            this.model.set('modified', '');
        }
      }

      this.render();
      
      // Get created_by & modified_by user from entity,
      // then re-render
      // @todo Enable passing in non-header-region-, but user-related,
      // component specific attributes (e.g. order.order_executed_by)

      if (typeof Radio._channels['users'] === 'undefined' || typeof Radio._channels['users']['_requests'] === 'undefined') {
          return;
      }

      const that = this,
            users = Radio.channel('users').request('get:data'),
            requests = {};

      let c = 0;

      const onRequestsFinished = function () {
        // Check whether all requests are finished, then re-render
        if (c++ === _.size(requests)) {
          that.render();
        }
      }

      // Fetch entity.created_by
      if (this.model.get('created_by') !== null
       && this.model.get('created_by') !== ''
       && typeof this.model.get('created_by').get === 'undefined') {

        requests.created_by = true;

        users.fetchById(that.model.get('created_by'), function (user) {
          
          if (user === undefined || user == null) {
            // User not existing
            that.model.set('created_by', null);
          } else {
            that.model.set('created_by', user);
          }

          onRequestsFinished();

        });
      }

      // Fetch entity.modified_by
      if (this.model.get('modified_by') !== null
       && this.model.get('modified_by') !== ''
       && typeof this.model.get('modified_by').get === 'undefined') {

        requests.modified_by = true;

        users.fetchById(this.model.get('modified_by'), function (user) {

          if (user === undefined || user == null) {
            // User not existing
            that.model.set('modified_by', null);
          } else {
            that.model.set('modified_by', user);
          }
          
          onRequestsFinished();

        });
      }

      onRequestsFinished();
  }

});

export default Marionette.Behavior.extend({

    options: {
        closeAfterSave : true,
        extraHeaderRegionContent : ''
    },

    ui: {
        headerRegion : '.off-canvas__header-region',
        submit: '.off-canvas__actions .button-submit',
        errorMessageField : '.off-canvas__form-error',
    },

    events: {
        'click @ui.submit': 'submitForm',
    },

    _closeCanvas () {

        if (this.view.canvas) {

            appChannel.trigger('destroy:backform');

            this.view.unbind();
            this.view.undelegateEvents();
            this.view.unbindEvents();
            this.view.unbindUIElements();
            //this.view.stopListening();
            //this.view._removeElement()
            //this.destroy();
            Backbone.history.navigate(this.view.parentView, { trigger : (typeof this.view.afterCloseTriggerNavigate === 'undefined' ? true : this.view.afterCloseTriggerNavigate) });
            //this.view = {};
        } 

    },

    initialize () {

        const that = this;

        // Inject close method into linked view
        this.view.closeCanvas = this._closeCanvas.bind(this);
        
        if (typeof this.view.el != 'undefined') {
            this.view.setElement(this.view.el);
        }
        
        // @todo request animation frame...
        if (this.view.parentView !== 'users') {
            // Bug: when called via OffCanvasUsersForm within select2.addEntity, this will put a loading indicator
            // to the background form
            this.view.$el.html('<h4 class="off-canvas__loading">' + this.view.t('loading') + '...</h4>');
        }

        if (typeof this.getOption('openCanvas') === 'undefined'
            || this.getOption('openCanvas')(this.view)) {
          
            if (typeof this.view.canvas == 'undefined') {
                this.view.canvas = new Foundation.OffCanvas(this.view.$el);
            }

            if (typeof this.view.canvas.open !== 'function') {
                return;
            }

            this.view.canvas.open();

            this.view.$el.on('closed.zf.offcanvas', () => {

                that.view.$el.foundation('_destroy');
                that.view.$el.off('closed.zf.offcanvas');

                if (that.getOption('beforeCanvasClose')) {
                  if (!that.getOption('beforeCanvasClose')(that.view)) {
                    // @todo This may ALWAYS execute _closeCanvas
                    // @TODO Interrupt close process
                    //that.view.$el.removeClass('is-closed')
                    //.addClass('is-open');
                    //that.canvas = new Foundation.OffCanvas(that.view.$el);
                    that._closeCanvas();
                  } else {
                    that._closeCanvas();
                  }
                } else { 
                  that._closeCanvas();
                }

            });
        } else {
            // is modal

            this.view.$el.on('closed.zf.reveal', () => {

              that.view.$el.foundation('_destroy');
              that.view.$el.off('closed.zf.reveal');

              that._closeCanvas();
            });
        }
    },

    onRender () {

        // Inject headerRegionView into parent view
        this.view.headerRegionView = new headerRegionView({ 

            el: this.getUI('headerRegion'),
            model: this.view.model,
            extraHeaderRegionContent: this.getOption('extraHeaderRegionContent')
        
        });
      
        this.view.$el.find('.off-canvas__actions')
                     .removeClass('hide');
        
        new Foundation.Abide(this.view.$el.find('form'), { liveValidate:true });
 
    },

    makeApiTime (_t) {

      const t = moment(_t, moment.ISO_8601);

      if (t.isValid()) {
        return t.format('YYYY-MM-DD HH:mm');
      }

      return _t;

    },

    // called before safe
    normalizeModel (model) {

      delete model.attributes.created;
      delete model.attributes.modified;
      delete model.attributes.deleted;
      delete model.attributes.created_by;
      delete model.attributes.modified_by;

      if (model.get('id') === '' || model.get('id') === null) {
        model.set('id', null);
      }

      // If a form was submitted without re-triggering the datepicker,
      // we may have to re-force formatting of time values:
      const begin = model.get('begin'),
            end = model.get('end');

      if (typeof begin !== 'undefined') {
        if (begin.indexOf('T') >= 0) {
          model.set('begin',moment(begin).format('YYYY-MM-DD HH:mm'));
        } 
      }

      if (typeof end !== 'undefined') {
        if (end.indexOf('T') >= 0) {
          model.set('end',moment(end).format('YYYY-MM-DD HH:mm'));
        } 
      }

      return model;

    },

    _requestInProgress : false,

    submitForm () {

      if (this._requestInProgress) return;

      this._requestInProgress = true;

      const that = this;
      let   model = this.view.form.model;

      if (typeof this.view.skipValidation === 'undefined') {
        this.view.$el.find('form').foundation('validateForm');
        this.view.$el.find('form .is-invalid-input.datepicker-time').removeClass('is-invalid-input');
      }
      
      if (model.isValid()) {

        if (!this.view.$el.find('form .is-invalid-input').length) {

          that.getUI('submit')
              .find('.fi')
              .addClass('hide');

          that.getUI('submit')
              .find('span')
              .prepend(appRollingLoaderAnim);
          
          model = this.normalizeModel(model);

          if (that.getOption('beforeSave') !== null) {
            that.getOption('beforeSave')(model, that.view);
          }

          model.save(null,{
            success (model, response, options) {

              that._requestInProgress = false;

              that.getUI('errorMessageField').addClass('hide');

              if (!response.success) {
                if (that.getOption('afterSaveError') != null) {
                  that.getOption('afterSaveError')(model, that.view, response);
                  return;
                }
              }

              if (that.getOption('afterSaveSuccess') != null) {
                that.getOption('afterSaveSuccess')(model, that.view, response);
              }

              if (typeof that.view.getOption('afterSaveSuccess') != 'undefined') {
                that.view.getOption('afterSaveSuccess')(model, that.view, response);
              }

              // Used e.g. in OrdersSidebarView()
              if (typeof that.view.getOption('afterSaveSuccess2') != 'undefined') {
                that.view.getOption('afterSaveSuccess2')(model, that.view, response);
              }

              if (that.getOption('closeAfterSave')) {
                if (typeof that.view.canvas != 'undefined') {
                  that.view.canvas.close();
                }
              }

              // if (isNew)
              // this.view.collection.add(model);

            }, error (model, xhr, options) {

              that._requestInProgress = false;

              if (that.getOption('afterSaveError') != null) {
                that.getOption('afterSaveError')(model, that.view, xhr);
              } else {
                that.getUI('errorMessageField')
                    .removeClass('hide') 
                    .html(that.view.t('request_error'))
                    .fadeIn('fast');
              }

              that.$('.rollingLoader')
                  .fadeOut('fast');
              
            }});

        } else {

          this.getUI('errorMessageField')
              .removeClass('hide')
              .html(that.view.t('form_validation_error'))
              .fadeIn('fast');

          this._requestInProgress = false;

        }
      } else {

        let errors = model.validationError;

        this.getUI('errorMessageField')
            .removeClass('hide')
            .html(_.isFunction(errors) ? errors(that.view.t) : that.view.t(model.validationError))
            .fadeIn('fast');

        model.validationError = null;

        this._requestInProgress = false;

      }

    }

  });